<p-table #dt [value]="stat.data" stateStorage="session" stateKey="structure-table-{{stat.caption}}"
  styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true">
  <ng-template pTemplate="colgroup" let-columns>
    <colgroup>
      <col style="width: 50px;">
      <!-- <col style="width: 32px;"> -->
      <col style="width: auto;">
      <col style="width: 110px;">
      <col style="width: 110px;">
    </colgroup>
  </ng-template>
  <ng-template pTemplate="caption">
    <div class="flex align-items-center justify-content-between">
      <h4 class="m-0">{{ stat.caption }} ({{ stat.n }})</h4>
      <p-button class="btn btn-secondary float-right" (click)="onExcel(dt.value)">Excel</p-button>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th  class="p-column-checkbox">#</th>
      <th  class="p-column-text" pSortableColumn="key">{{ categoryName }} <p-sortIcon field="key"></p-sortIcon>
      </th>
      <th  class="p-column-number" pSortableColumn="value">Кол-во <p-sortIcon field="value"></p-sortIcon>
      </th>
      <th  class="p-column-number" pSortableColumn="percent">% <p-sortIcon field="percent"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item let-idx="rowIndex">
    <tr>
      <td class="p-column-checkbox">{{ idx + 1 }}</td>
      <td class="p-column-text">{{item.key}}</td>
      <td class="p-column-number">{{item.value}}</td>
      <td class="p-column-number">{{item.percent}}</td>
    </tr>
    <tr class="row-total" *ngIf="idx+1 === stat.data.length">
      <td  class="p-column-checkbox"></td>
      <td  class="p-column-text">ИТОГО</td>
      <td  class="p-column-number">{{ stat.n }}</td>
      <td  class="p-column-number">100</td>
    </tr>
  </ng-template>

</p-table>
